/* global confirm */
define((require) => {
    "use strict";

    var $                 = require("jquery"),
        AddBreakpointView = require("ui/settings/breakpoint/AddBreakpointView"),
        EditorEvents      = require("shared/services/EditorEvents"),
        Lightbox          = require("shared/ui/common/Lightbox"),
        Permissions       = require("shared/security/Permissions"),
        SettingsView      = require("ui/settings/SettingsView"),
        template          = require("ui/settings/breakpoint/BreakpointSettingsView.tpl");

    /**
     * View for defining company breakpoints.
     *
     * @cfg {BreakpointCollection} collection The collection of <tt>Breakpoints</tt>'s.
     *
     * @class BreakpointSettingsView
     */
    return SettingsView.extend("BreakpointSettingsView", {

        className: SettingsView.prototype.className + " breakpoint-setup-view",

        template: template,

        templateHelpers: function() {
            // Make sure the collection of breakpoints are sorted - we don't need to call this under
            // normal circumstances, as a collection with a comparator will sort itself whenever a model is added.
            // But when we change a threshold value, we need to make sure the collection is sorted...
            this.collection.sort();

            return {
                permissionToManage: Permissions.Privileges.ADMIN.can(),
                breakpoints: this.collection,
                naming: this.collection.generateNaming()
            };
        },

        events: {
            "click .add": "openAddBreakpointBox",

            "blur .breakpoint-input": function(event) {
                var $target = $(event.target),
                    threshold = parseInt($target.val(), 10),
                    index = parseInt($target.data("index"), 10),
                    breakpoint = this.collection.at(index);

                if (threshold > 1) {
                    this.updateThreshold(index, threshold);
                } else {
                    $target.val(breakpoint.get("threshold"));
                }
            },

            "click .delete-breakpoint": function(event) {
                var index = parseInt($(event.target).data("index"), 10),
                    breakpoint = this.collection.at(index);

                if (confirm("Are you sure you want to delete the " + breakpoint.get("threshold")  + " px Breakpoint?")) {
                    this.deleteBreakpoint(index);
                }
            },

            "keyup .variant": function(event) {
                var $target = $(event.target);

                if ($target.val().length > 4) {
                    $target.val($target.val().slice(0, 4));
                }
            }
        },

        collectionEvents: {
            "add remove change": "render"
        },

        /**
         * Open a light box where users input the new breakpoint.
         */
        openAddBreakpointBox: function() {
            var addBreakpointView = new AddBreakpointView({
                    collection: this.collection
                }),
                box = new Lightbox(addBreakpointView, {
                    win: false,
                    css: {width: 440},
                    editorEventProperties: {
                        modalType: "AddBreakpoint",
                        triggerOrigin: "AddBreakpointModal"
                    }
                });

            box.open();
        },

        /**
         * Updates the threshold value of the breakpoint at the specified index.
         *
         * @param {Number} index The index of the breakpoint to update.
         * @param {Number} threshold The new threshold value.
         */
        updateThreshold: function(index, threshold) {
            this.collection.at(index).set("threshold", threshold);

            var eventProperties = {
                groupType: "BreakpointGroup",
                updatedProperty: "threshold",
                updatedValue: threshold,
                triggerOrigin: "UpdateBreakpointThresholdButton"
            };

            EditorEvents.trigger(EditorEvents.constants.UPDATE_BREAKPOINT, eventProperties);
        },

        /**
         * Delete a breakpoint by index.
         *
         * @param {Number} index The index of breakpoint to be deleted
         */
        deleteBreakpoint: function(index) {
            var collection = this.collection,
                breakpoint = collection.at(index);

            collection.remove(breakpoint);

            var eventProperties = {
                threshold: breakpoint.get("threshold"),
                triggerOrigin: "DeleteBreakpointButton"
            };

            EditorEvents.trigger(EditorEvents.constants.DELETE_BREAKPOINT, eventProperties);
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/breakpoint/BreakpointSettingsView.js